import { IAnswerParams } from "../../repository/props";

export const answerComment = (payload?: IAnswerParams) => ({
  type: "@saga/ANSWER_COMMENT",
  payload,
});
